// removed by extract-text-webpack-plugin
module.exports = {"Item":"_34xnD","ItemActive":"_25-uh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Common/CommonNavItem/CommonNavItem.scss
// module id = 580
// module chunks = 0